module.exports = __webpack_public_path__ + "static/media/5.9da2fb58.jpg";